import { render, staticRenderFns } from "./VarietyInformation.vue?vue&type=template&id=1707e5bf&scoped=true&"
import script from "./VarietyInformation.vue?vue&type=script&lang=js&"
export * from "./VarietyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707e5bf",
  null
  
)

export default component.exports